import { Badge } from '@chakra-ui/react';
import { dateFormatter } from 'app/helpers/format-helper';
import { AttendanceSource } from 'app/types/uconnect';
import { isManualAttendanceSource } from 'app/uconnect/helpers/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  source?: AttendanceSource | null;
  edited?: boolean;
  editedAt?: string | null;
};

export const AttendanceProvenanceBadge: React.FC<Props> = ({ source, edited, editedAt }) => {
  const { t } = useTranslation();

  if (edited || isManualAttendanceSource(source)) {
    return (
      <Badge colorScheme="orange" variant="subtle" whiteSpace="nowrap">
        {editedAt ? t('connect.editedAgo', { time: dateFormatter.relativeTime(editedAt) }) : t('connect.edited')}
      </Badge>
    );
  }

  if (source === AttendanceSource.LearnerJoin) {
    return (
      <Badge colorScheme="blue" variant="subtle" whiteSpace="nowrap">
        {t('connect.autoTracked')}
      </Badge>
    );
  }

  if (source === AttendanceSource.ZoomApi) {
    return (
      <Badge colorScheme="green" variant="subtle" whiteSpace="nowrap">
        {t('connect.zoomSync.verified')}
      </Badge>
    );
  }

  return null;
};
